export default __webpack_public_path__ + "static/media/section4-bg.f65c03f5.png";